<template>
  <div
    class="container-fluid"
    :class="[store.isMobile ? 'mobile-layout' : 'desktop-layout']"
  >
    <router-view />
  </div>
</template>

<script>
import { store } from "./store/store";

export default {
  name: "App",

  data() {
    return {
      store,
      events: ["resize", "load"],
    };
  },

  methods: {
    checkIsMobile() {
      store.isMobile = window.innerWidth < 768;
    },
  },

  mounted() {
    this.events.forEach((event) => {
      window.addEventListener(event, this.checkIsMobile);
    });
  },
};
</script>

<style lang="scss">
@import "assets/css/variables.scss";

/* Estilo do título de cada página */

h1.page-title {
  font-size: $h3;
  color: $azul-principal;
  text-align: center !important;
  font-weight: bold;
  margin-bottom: 1em;
}

/* Estilo padrão dos botões */

button.default {
  padding: 1em 3em;
  height: 3.75em;
  border-radius: 10px;
  border: none;
  color: $branco-neutro;
  background-color: $azul-principal;
  font-weight: bold;
  font-size: $btn-sm;
}

/* Estilo mini dos botões */

button.default.mini {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  //margin-left: 5px;
  padding: 0;
  line-height: 10px;

  img {
    width: 100%;
  }
}

/* Estilo padrão dos botões de ação */

button.action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: $azul-principal;
  border: none;
  text-align: center;
  vertical-align: middle;

  img {
    display: flex;
    margin: auto;
  }
}

/* Estilo geral de botões */

button:not([disabled]):hover {
  background-color: $verde-auxiliar;
  cursor: pointer;
}

button:disabled {
  background-color: $cinza-4;
}

/* Estilo padrão da legenda */

span.subtitle {
  display: block;
  color: $azul-principal;
  font-size: $subtitle;
  text-align: center;
}

/* Estilo padrão de formulário */

// Label
label.form-default {
  color: $cinza-3;
  font-size: $text-lg;
  font-weight: $bold;
  margin-bottom: 0.5rem;
}

@mixin formDefault() {
  width: 100%;
  height: 3.25em;
  font-size: $text-md;
  color: $cinza-3;
  border-radius: 10px;
  padding: 1em 1.5em;
  line-height: 1;
  border: 1px solid $preto-3;
  transition: 0.25s linear;
}

// Text
input[type="text"].form-default {
  @include formDefault();
}

//Text com focus
input[type="text"].form-default:focus {
  color: $cinza-2;
}

// Select
select.form-default {
  @include formDefault();

  background-color: $branco-neutro;
  background-image: url("assets/svg/arrow-select.svg");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;

  transition: 0.25s linear;

  appearance: none;
  cursor: pointer;
}

//Select com focus
select.form-default:focus {
  color: $preto-3;
}

select.form-default:disabled {
  background-color: $cinza-5;
}

// Feedback negativo
div.invalid-feedback {
  display: block;
  font-size: $text-lg;
}

//Checkbox
input[type="checkbox"].checkbox-default {
  width: 25px;
  vertical-align: middle;
  cursor: pointer;
}

input[type="checkbox"].checkbox-default:before {
  content: "";
  display: block;
  width: 25px;
  height: 25px;
  background-color: $azul-principal;
  border: solid 3px $branco-neutro;
}

input[type="checkbox"].checkbox-default:checked:after {
  content: "";
  display: block;
  position: relative;
  left: 6px;
  top: -19px;
  border: solid $branco-neutro;
  width: 13px;
  height: 13px;
  background-color: $branco-neutro;
}

//Checkbox com as cores invertidas
input[type="checkbox"].checkbox-default.inverted:before {
  background-color: $branco-neutro;
  border: solid 3px $azul-principal;
}

input[type="checkbox"].checkbox-default.inverted:checked:after {
  border: solid $azul-principal;
  background-color: $azul-principal;
}

/* Painel de ações */

.action-panel {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-bottom: 1em;
  align-items: center;

  button.action-text {
    display: flex;
    padding: 1em;
    height: 4em;
    border-radius: 10px;
    background-color: $azul-principal;
    font-weight: $bold;
    border: none;
    text-align: center;
    vertical-align: middle;
    margin-left: 1em;
    white-space: nowrap;
    align-items: center;

    span {
      color: $branco-neutro;
      margin-right: 1em;
    }

    img {
      display: flex;
      margin: auto;
    }
  }

  button.action-text:hover {
    background-color: $verde-auxiliar;
  }
}

/* Estilo padrão do input de carregar arquivos */

label.input-file-default {
  display: flex;

  .button-file {
    position: relative;
    display: flex;
    //width: 200px;
    border: hidden;
    border-radius: 10px 0 0 10px;
    color: $azul-principal;
    font-size: $btn-sm;
    cursor: pointer;
    font-weight: $bold;
    background: $cinza-5;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
    padding: 1em 1.5em;
    align-items: center;
  }

  .button-file span {
    margin-left: 1em;
  }

  .field-submit-file {
    width: 75%;
    border: 1px solid $preto-3;
    border-radius: 0 10px 10px 0;
    background-color: $branco-neutro;
    color: $cinza-2;
    font-size: $text-md;
    cursor: pointer;
    padding: 1em 1.5em;
  }

  input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  input[type="file"]:disabled {
    cursor: default;
  }

  .field-submit-file:disabled {
    background-color: #e9ecef;
    color: #282828;
    cursor: default;
  }

  .field-submit-file.is-invalid {
    border-color: $erro;
  }
}

/* Estilo padrão dos alertas */

div.alert-default {
  position: relative;
  padding: 1rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid $cinza-4;
  border-radius: 0.25rem;
  text-align: center;
  color: $cinza-2;
  background-color: $cinza-5;
  font-weight: $bold;
  word-wrap: break-word;
  font-size: $text-md;
}

@media (max-width: $mobile-bp) {

  /* Estilo do painel de ações */

  .action-panel {
    flex-wrap: wrap;
    button.action-text {
      justify-content: center;
      width: 100%;
      margin: 1em 0 0;
      img {
        margin: 0;
      }
    }
  }

  /* Estilo do título de cada página */

  h1.page-title {
    font-size: $h4;
    color: $azul-principal;
    text-align: center !important;
    font-weight: bold;
    margin-bottom: 1em;
  }

  /* Estilo padrão do input de carregar arquivos */

  label.input-file-default {
    .button-file span {
      display: none;
    }

    .button-file {
      width: 70px;
    }
  }
}

/* Estilos para a visualização desktop */
.desktop-layout {
  .col-md-3 {
    width: 17.5rem !important;
    margin-right: 0 !important;
    padding-right: 0 !important;
  }

  .col-md-9 {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  height: 100vh;
}

/* Estilos para a visualização mobile */
.mobile-layout {
  .col-md-3 {
    width: 17.5rem !important;
    margin-right: 0 !important;
    padding-right: 0 !important;
  }

  .col-md-9 {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  height: 100vh;
}

.container-fluid {
  padding-right: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

/* Estilização da barra de rolagem */
/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: $branco-neutro;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: $branco-neutro;
}

*::-webkit-scrollbar-thumb {
  background-color: $azul-principal;
  border-radius: 20px;
}
</style>
